/// <amd-module name="Artifacts/Package/web-apis/RestClient/AnyProtocolPackagingInternal" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   packaging\client\crossprotocol\internal.webapi\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as AnyProtocolPackagingInternal from "Artifacts/Package/web-apis/Contracts/AnyProtocolPackagingInternal";

import { IAnyProtocolPackagingInternalRestClient } from "Artifacts/Package/web-apis/RestClient/AnyProtocolPackagingInternal.Types";

export { IAnyProtocolPackagingInternalRestClient } from "Artifacts/Package/web-apis/RestClient/AnyProtocolPackagingInternal.Types";

class AnyProtocolPackagingInternalRestClient extends RestClientBase implements IAnyProtocolPackagingInternalRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Trigger the ingestion job for a feed+protocol+package
     * 
     * @param triggerParameters - 
     * @param protocol - 
     * @param feedId - 
     * @param packageName - 
     * @param packageVersion - 
     * @param project - Project ID or project name
     */
    public async ingestFromUpstream(
        triggerParameters: AnyProtocolPackagingInternal.ManualUpstreamIngestionParameters,
        protocol: string,
        feedId: string,
        packageName: string,
        packageVersion: string,
        project?: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/packaging/feeds/{feedId}/{protocol}/packages/{packageName}/versions/{packageVersion}/ManualUpstreamIngestion",
            routeValues: {
                project: project,
                protocol: protocol,
                feedId: feedId,
                packageName: packageName,
                packageVersion: packageVersion
            },
            body: triggerParameters
        });
    }

}

export const AnyProtocolPackagingInternalClientName = "IAnyProtocolPackagingInternalRestClient";

export function getAnyProtocolPackagingInternalClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IAnyProtocolPackagingInternalRestClient {
    return pageContext.getRestClient<IAnyProtocolPackagingInternalRestClient>(AnyProtocolPackagingInternalClientName, options);
}

RestClients.add(AnyProtocolPackagingInternalClientName, { 
    factory: AnyProtocolPackagingInternalRestClient,
    options: {
        resourceAreaId: "e54d3adc-d485-4536-b63d-1bd2bfc179bf",
        serviceInstanceType: "00000030-0000-8888-8000-000000000000"
    }
});
